import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, RentCollectionData, SyncData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CancelIcon from '@mui/icons-material/Cancel';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { faVolleyball } from '@fortawesome/free-solid-svg-icons';
import { IconButton, TableCell, Modal, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';
import { Tooltip } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import BillPrint from './Bill';
import ReactDOM from 'react-dom';
import PaidIcon from '@mui/icons-material/Paid';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

function RentedCustomerIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        fetchtableData();
        setLoading(true);
    }, [isAuthenticated, companyId, userId, token, logout]);


    useEffect(() => {
        handleToDateChange();
    }, []);

    const fetchtableData = async () => {
        // fetchData('CustomerApi', `/${companyId}`, token)
        RentCollectionData('RentCollectionsApi', toDate, companyId, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Customer Details:', error);
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };


    const handleDelete = async () => {
        deleteData('RentCollectionsApi', `${deleteItemId}`, token)
            .then((response) => {

                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('RentCollectionsApi', `${itemId}`, token)
            .then((response) => {

            })
            .catch((error) => {
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDatas = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    function formatDate(dateString) {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'long' });
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }


    const [filteredData, setFilteredData] = useState([]);

    const handleToDateChange = async (event) => {
        const selectedDate = event?.target?.value;
        if (!selectedDate) return;
        setData([]);
        setToDate(selectedDate);
        setLoading(true);
        try {
            const response = await RentCollectionData('RentCollectionsApi', selectedDate, companyId, token);
            if (response.responseCode === '1111') {
                if (response.response_data && response.response_data.length > 0) {
                    console.log(response);
                    setData(response.response_data);
                } else {
                    console.warn('No data available for the selected date.');
                    setData([]); // or handle it appropriately
                }
            } else {
                console.error('Failed to fetch data:', response.responseMessage || 'Unknown error');
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
        }
        finally{
            setLoading(false); // Hide loading screen
        };
    };


    const handlePrint = async (customerid) => {
        try {
            // Fetch data
            setIsLoading(true);
            const response = await fetchData('RentCollectionsApi', `/RentCollectionPrint/${customerid}/${userId}/${toDate}`, token);
            const labelData = response.response_data;
            // Array.isArray(response.response_data) ? response.response_data : [response.response_data];
            console.log(response);
            console.log(labelData);
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');


            ReactDOM.render(
                <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,

                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();

            iframe.contentWindow.print();
            await handleToDateChange({ target: { value: toDate } });
            try {
                await SyncData('RentCollectionsApi', `${customerid}`, token);
            } catch (updateError) {
                console.error('Error updating record:', updateError);
            }
        } catch (error) {
            console.error('Error printing Estimate:', error);
        }
    };


    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ maxWidth: '95%' }}>

            <div className='w-full mb-2 flex flex-col md:flex-row items-center'>
                <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>
                    RENT RETRIVAL
                </h6>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div>
                            <CircularProgress style={{ color: 'white' }} />
                            <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                        </div>
                    </div>
                )}
                <div className='flex flex-col md:flex-row md:items-center md:ml-auto mt-2 md:mt-0 w-full md:w-auto'>
                    <div className='flex flex-col mb-2 md:mb-0 md:mr-4'>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="date"
                            id="todayDate"
                            name="todayDate"
                            value={toDate}
                            onChange={handleToDateChange}
                        />
                    </div>
                    <div className='flex items-center'>
                        <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                        {showSearchInput && (
                            <input
                                className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={handleSearch}
                                style={{ marginLeft: '10px', width: '150px' }}
                            />
                        )}
                    </div>
                </div>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '490px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    {data.length > 0 ? (
                        <Table>
                            <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                                <TableRow>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '5px', color: 'black' }}>Invoice Print</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '5px', color: 'black' }}>Name</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '5px', color: 'black' }}>Room</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '5px', color: 'black' }}>Amount</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {data.map((item, index) => (
                                    <TableRow
                                        key={item.Id}
                                        className="customTableRows"
                                        sx={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#e0e0e0' }} // Alternating light colors
                                    >
                                        <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '14px' }}>
                                            <Tooltip title="Generate Bill">

                                                <IconButton onClick={() => handlePrint(item.CustomerId)} disabled={isLoading}>
                                                    <ArrowForwardIcon style={{ color: 'darkblue' }} />{isLoading ? <CircularProgress size={24} color="inherit" /> : <b></b>}
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '14px' }}>
                                            {item.CustomerName}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '14px' }}>
                                            {item.RoomName}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '14px' }}>
                                            {item.RoomRent}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>

                        </Table>
                    ) : (
                        <div style={{ padding: '20px', textAlign: 'center', color: 'grey' }}>
                            No data available
                        </div>
                    )}
                </TableContainer>
            </div>

        </div >
    );
}

export default RentedCustomerIndex;

